import React, { ChangeEvent, MouseEvent, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import './NavMenu.scss'
import { ROUTES } from '../../lib/constants'
import { SVGIcon } from '../SVGIcon/SVGIcon'
import { Button } from '../Button/Button'

export const NavMenu = (props: { open: boolean }): React.JSX.Element => {
  const refs = useRef<HTMLInputElement[]>([])

  const refCallback = (el: HTMLInputElement | null): void => {
    refs.current.push(el as HTMLInputElement)
  }

  const onChangeCallback = (e: ChangeEvent): void => {
    refs.current.forEach((input) => {
      if (input && input !== e.target) input.checked = false
    })
  }

  const onBack = (): void => {
    refs.current.forEach((input) => {
      if (input) input.checked = false
    })
  }

  const onBtnClick = (e: MouseEvent<HTMLButtonElement>): void => {
    (e.target as HTMLButtonElement).querySelector('input')?.click()
  }

  useEffect(() => {
    if (props.open) {
      refs.current.forEach((input) => {
        if (input) input.checked = false
      })
    }
  }, [props.open])

  return (
    <nav className="nav-menu" data-open={props.open}>
      <button className="nav-menu__back-nav" onClick={onBack}>
        <SVGIcon id="arrow" color="marina-blue" /> Main Menu
      </button>

      <ul>
        <li>
          <button onClick={onBtnClick}>
            Home Internet
            <input
              type="checkbox"
              ref={refCallback}
              onChange={onChangeCallback}
            />
          </button>
          <ul>
            <li>
              <Link className="focus-contrast" to={ROUTES.gigInternet.path}>
                View All Packages
              </Link>
            </li>
            <li>
              <Link
                className="focus-contrast"
                to={ROUTES.connectAndControl.path}
              >
                <span>1 Gig</span>
                <span className="color--daylight-blue">Connect & Control</span>
              </Link>
            </li>
            <li>
              <Link
                className="focus-contrast"
                to={ROUTES.workHardPlayHard.path}
              >
                <span>2 Gigs</span>
                <span className="color--orange-gradient">
                  Work Hard, Play Hard
                </span>
              </Link>
            </li>
            <li>
              <Link
                className="focus-contrast"
                to={ROUTES.everythingAndEverywhere.path}
              >
                <span>5 Gigs</span>
                <span className="color--ocean-blue">
                  Everything & Everywhere
                </span>
              </Link>
            </li>
          </ul>
        </li>
        <li>
          <button onClick={onBtnClick}>
            Business Internet
            <input
              type="checkbox"
              ref={refCallback}
              onChange={onChangeCallback}
            />
          </button>
          <ul>
            <li>
              <Link
                className="focus-contrast"
                to={ROUTES.smartBiz.path}
              >
                SmartBiz
              </Link>
            </li>
          </ul>
        </li>
        <li>
          <button onClick={onBtnClick}>
            Communities
            <input
              type="checkbox"
              ref={refCallback}
              onChange={onChangeCallback}
            />
          </button>
          <ul>
            <li>
              <Link
                className="focus-contrast"
                to={ROUTES.apartmentProjects.path}
              >
                Apartment Projects
              </Link>
            </li>
            <li>
              <Link className="focus-contrast" to={ROUTES.hoaProjects.path}>
                HOA Projects
              </Link>
            </li>
          </ul>
        </li>
        <li>
          <button onClick={onBtnClick}>
            About
            <input
              type="checkbox"
              ref={refCallback}
              onChange={onChangeCallback}
            />
          </button>
          <ul style={{ gap: '1vh' }}>
            <li>
              <Link className="focus-contrast" to={ROUTES.aboutUs.path}>
                About Us
              </Link>
            </li>
            <li>
              <Link className="focus-contrast" to={ROUTES.referralProgram.path}>
                Referral Program
              </Link>
            </li>
            <li>
              <Link className="focus-contrast" to={ROUTES.joinOurTeam.path}>
                Join Our Team
              </Link>
            </li>
           <li>
              <Link className="focus-contrast" to={ROUTES.construction.path}>
                Construction
              </Link>
            </li>
             {/* <li>
              <Link
                className="focus-contrast"
                to={ROUTES.currentServiceAreas.path}
              >
                Current Service Areas
              </Link>
            </li> */}
            <li>
              <Link className="focus-contrast" to={ROUTES.streaming.path}>
                Streaming
              </Link>
            </li>
            <li>
              <Link className="focus-contrast" to={ROUTES.aboutFiber.path}>
                About Fiber
              </Link>
            </li>
            <li>
              <Link
                className="focus-contrast"
                to={ROUTES.blog.altPath as string}
              >
                Blog & News
              </Link>
            </li>
          </ul>
        </li>
      </ul>

      <div className="nav-menu__lower-btns">
        <Button
          className="btn--md-extra-padding"
          href={ROUTES.checkAvailability.path}
          target="_self"
          size="md"
          fullWidth={true}
        >
          Check Availability
        </Button>

        <Button
          className="btn--md-extra-padding bg-color--orange"
          path={ROUTES.login.path}
          target="_self"
          size="md"
          fullWidth={true}
        >
          Log In
        </Button>
      </div>
    </nav>
  )
}
